import { BulkResponse, BulkResponseError } from '@/types/bulk-response'

export default function batchErrorHandler<ItemType>(
  results: BulkResponse<ItemType>,
) {
  // An item failed only if it carries actual error entries. A success comes back
  // with `errors: null`, and an empty object is not a failure either.
  const errorResults = results.filter(
    (result) => result.errors && Object.keys(result.errors).length > 0,
  )
  errorResults.forEach((result) => {
    const entries = Object.entries(result.errors ?? {}) as [
      string,
      BulkResponseError[],
    ][]
    entries.forEach(([propertyKey, errors]) => {
      errors.forEach((error) => {
        console.error(
          `Batch Create/Update/Delete Error: \n\tStatus: ${result.status_code} \n\tStatus Text: ${result.status_text} \n\tAction: ${result.action} \n\tKey: ${propertyKey} \n\tCode: ${error.code}\n\tMessage: ${error.message} \n\tItem ID: ${result.id}`,
        )
      })
    })
  })
  return errorResults
}
